import api from '../../../utils/functions/api';

import {
  PROMOTION_BILL_PRICE_ALL,
  PROMOTION_BILL_PRICE_CREATE,
  PROMOTION_BILL_PRICE_GET,
  PROMOTION_BILL_PRICE_UPDATE,
  PROMOTION_BILL_PRICE_DELETE,
  PROMOTION_BILL_PRICE_ERROR,
} from '../types';

// faker.locale = "th"

export const getAllPromotionBillPrice = (params) => async (dispatch) => {
  try {
    const { name = '', size = '', page = 1 } = params;
    const { data, status } = await api.get(
      `${process.env.REACT_APP_API_URL}/promotion-bill-price?name=${name}&size=${size}&page=${page}`,
    );
    if (status === 200) {
      dispatch({ type: PROMOTION_BILL_PRICE_ALL, payload: data });
    }
  } catch (error) {
    console.error(error);
    dispatch({ type: PROMOTION_BILL_PRICE_ERROR });
    throw new Error(error);
  }
};

export const getOnePromotionBillPrice = (id) => async (dispatch) => {
  await api
    .get(`${process.env.REACT_APP_API_URL}/promotion-bill-price/${id}`)
    .then((res) => {
      console.log('Request Server to Get One option');
      if (res.data) {
        dispatch({ type: PROMOTION_BILL_PRICE_GET, payload: res.data });
      } else {
        dispatch({ type: PROMOTION_BILL_PRICE_GET, payload: null });
      }
    });
};
export const createOnePromotionWithBillPrice = (payload) => async (
  dispatch,
) => {
  await api
    .post(`${process.env.REACT_APP_API_URL}/promotion-bill-price/`, payload)
    .then(() => {
      console.log('Request Server to Create New option');
      dispatch({ type: PROMOTION_BILL_PRICE_CREATE });
    });
};

export const editOnePromotionWithBillPrice = (id, payload) => async (
  dispatch,
) => {
  await api
    .put(`${process.env.REACT_APP_API_URL}/promotion-bill-price/${id}`, payload)
    .then(() => {
      console.log('Request Server to edit option');
      dispatch({ type: PROMOTION_BILL_PRICE_UPDATE });
    });
};

export const deleteOnePromotionWithBillPrice = (id) => async (dispatch) => {
  await api
    .delete(`${process.env.REACT_APP_API_URL}/promotion-bill-price/${id}`)
    .then(() => {
      console.log('Request Server to Delete One option');
      dispatch({ type: PROMOTION_BILL_PRICE_DELETE, payload: null });
    });
};
